import { BaseComponent } from '../../../../components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { VBox } from '../../../../components/Box';
import { Card } from '../../../../components/Card';
import { Row, Cell, List } from '../../../../components/List';
import { HBox } from '../../../../components/Box';
import { Modal, ModalControls } from '../../../../components/Modal';
import { FormField } from '../../../../components/FormFields';
import { Input } from '../../../../components/Input';
import { selectAddressTypes } from '../../../Address/selectors';
import { setNewInvoiceValue, updateInvoice } from '../../actions';
import { CompanyStatusCard } from '../../../Companies/components/StatusLabel';
import { Button } from '../../../../components/Buttons';
import { CompanySelection } from '../../../Companies/components/CompanySelection';
import { CreditorField } from './FieldsCreditor';
import { ViesLabel } from '../../../Companies/components/ViesLabel';
import { Loader } from '../../../../components/Loader';
import { checkVies, fetchCompany } from '../../../Companies/actions';
import { BTW_COUNTRIES, REQUEST_COMPANY, REQUEST_VIES_CHECK } from '../../../Companies/constants';
import { selectNewInvoice } from '../../selectors';
import { selectWorks } from '../../../Api/selectors';
import { getPropByName } from '../../../../utils/props';
import ModalComponent from '../../../../containers/App/Components/Modal/Modal';
import ButtonComponent from '../../../../containers/App/Components/Button/Button';

const Container = styled.div`
  font-size: 14px;
  h3 {
    font-size: 20px;
  }
  .regplate {
  }

  .company-link {
    &:hover {
      cursor: pointer;
      text-decoration: underline;
    }
  }

  .status-label {
    width: fit-content;
  }
`;

const STATE = {
  incomingCompanyEdit: false,
  selectedCompanyId: null,
  selectedCompanyLabel: null,
};
/* eslint-disable react/prefer-stateless-function */
class CreditorInfoCardComp extends BaseComponent {
  constructor(props) {
    super(props, {
      ...STATE,
    });
  }

  componentDidMount() {}

  componentDidUpdate(prevProps, prevState) {
    if (this.props.lastViesChecking !== prevProps.lastViesChecking) {
      this.props.fetchCompany(res => {
        if (res?.id) {
          this.setState({
            viesStatus: getPropByName(res, 'viesCheckStatus'),
            viesDate: getPropByName(res, 'viesCheckDate'),
            loading: false,
          });
        }
      });
    }
  }

  get dto() {
    return {
      incomingCompanyId: this.getFieldValue('incomingCompanyId'),
    };
  }

  get companyLabel() {
    let label = this.getFieldValue('incomingCompanyLabel', 'invoice') ?? '';
    if (this.getFieldValue('company_type') && this.getFieldValue('company_type') === 'individual') {
      label = `${this.getFieldValue('name') ?? ''} ${this.getFieldValue('surname') ?? ''}`;
    }
    return label;
  }

  getFieldValue(fieldName, object) {
    if (Object.keys(this.state).includes(fieldName)) {
      return this.state[fieldName];
    }
    if (object == 'invoice') {
      return this.props.invoice[fieldName];
    }

    if (fieldName == 'addresses') {
      return this.props.invoice?.incomingCompany?.addresses || [];
    }

    if (fieldName == 'status') {
      return this.props.invoice?.incomingCompany?.status;
    }
    return this.props.invoice?.incomingCompany?.[fieldName];
  }

  onViesCheck(event) {
    let options = BTW_COUNTRIES.map(c => ({ value: c.code, label: `${c.code}-${c.country}` }));
    const isWithCode = options.find(o => this.props.values?.BTW_number?.includes(o.value));
    let dto = {};
    if (isWithCode?.value) {
      dto = {
        id: this.props.invoice?.incomingCompany?.id,
        entity: 'company',
        countryCode: isWithCode?.value,
        vatCode: this.props.values?.BTW_number?.substring(2),
      };
      return this.props.checkViesStatus(dto, result => {
        this.setState({ loading: true });
        this.props.fetchCompany(res => {
          if (res?.id) {
            this.setState({
              viesStatus: getPropByName(res, 'viesCheckStatus'),
              viesDate: getPropByName(res, 'viesCheckDate'),
              loading: false,
            });
          }
        });
      });
    }
    return;
  }

  onEditIncomingCompany() {
    this.setState(prev => {
      return { ...prev, incomingCompanyEdit: true };
    });
  }

  onChangeCompanySelection(company) {
    this.setState(prev => {
      return { ...prev, selectedCompanyLabel: company.name ?? company.name ?? '', selectedCompanyId: company.id };
    });
  }

  closeIncomingCompanyEdit() {
    this.setState(prev => {
      return { ...prev, incomingCompanyEdit: false, selectedCompanyId: null, selectedCompanyLabel: null };
    });
  }

  onChangeIncomingCompany() {
    this.setState({ loading: true });
    return this.onUpdate({ incomingCompanyId: this.getFieldValue('selectedCompanyId') }, res => {
      if (res.id) {
        ['addresses', 'IBAN', 'BTW_number', 'customernumber', 'company_from_eu'].map(type =>
          this.props.setValue(res?.incomingCompany?.[type], type),
        );
      }
    });
  }

  renderIncomingCompanyEdit() {
    if (!this.getFieldValue('incomingCompanyEdit', 'invoice')) return '';

    return (
      <ModalComponent title={this.lbl('confirm')} onClose={this.closeIncomingCompanyEdit.bind(this)}>
        {this.state.selectedCompanyId ? (
          <VBox>{this.state.selectedCompanyLabel}</VBox>
        ) : (
          <CompanySelection
            order
            user={{ id: this.getFieldValue('incomingCompanyId', 'invoice') }}
            onSelect={this.onChangeCompanySelection.bind(this)}
          />
        )}
        {this.state.loading && <Loader small />}

        <div className="mt-2 d-flex gap-2">
          <ButtonComponent
            style="ButtonSoftEdit"
            disabled={this.state.loading}
            onClick={this.onChangeIncomingCompany.bind(this)}
          >
            {this.lbl('add')}
          </ButtonComponent>
          <ButtonComponent style="ButtonSoftDelete" onClick={this.closeIncomingCompanyEdit.bind(this)}>
            {this.lbl('cancel')}
          </ButtonComponent>
        </div>
      </ModalComponent>
    );
  }

  onUpdate(dto, callback) {
    this.props.update(dto, callback);
  }

  render() {
    const invoice = this.props.invoice;
    const homeTypeId = this.props.addressTypes.filter(t => t.name === 'home')[0].id;
    return (
      <Card className="vehicle-info-card info-card info">
        <Container width={window.innerWidth}>
          {this.renderIncomingCompanyEdit()}
          <HBox vCenter>
            <h2>{this.lbl('invoice.details.card.creditor')}</h2>
            <p className="company-link" onClick={this.tofn(`/companies/${invoice?.incomingCompany?.id}`)}>
              go to details
            </p>
          </HBox>
          <List>
            <Row key={'name'} onClick={this.onEditIncomingCompany.bind(this)}>
              <Cell>{this.lbl(`vehicle.property.creditor_company`)}</Cell>
              <Cell>
                <FormField>
                  <input
                    className="form-control"
                    capitalizedValue={
                      this.getFieldValue('company_type') && this.getFieldValue('company_type') === 'individual'
                    }
                    name="name"
                    value={this.companyLabel}
                    onChange={this.onInputChange.bind(this)}
                  />
                </FormField>
              </Cell>
            </Row>

            {this.getFieldValue('addresses') && (
              <Row key={'addresses'}>
                <Cell>{this.lbl(`company.property.address`)}</Cell>
                <Cell>
                  {this.getFieldValue('addresses')?.length &&
                    this.getFieldValue('addresses').map(address =>
                      address.typeId == homeTypeId
                        ? `${address.addressLine1 || ''}; ${address.postcode || ''}; ${address.city || ''} `
                        : '',
                    )}
                </Cell>
              </Row>
            )}
            {this.props.types.map(type => {
              if (type == 'BTW_number') {
                return (
                  <div key={type} style={{ display: 'contents' }}>
                    <CreditorField
                      isRequire={this.props.isRequire}
                      key={type}
                      type={type}
                      invoice={invoice}
                      homeAddresId={homeTypeId}
                    />
                    <Row vCenter center>
                      {' '}
                      <Cell>
                        <Button disabled={this.props.viesWork} onClick={() => this.onViesCheck()}>
                          {this.props.viesWork ? <Loader small /> : 'Vies check'}
                        </Button>
                      </Cell>
                    </Row>
                  </div>
                );
              }
              return (
                <CreditorField
                  isRequire={this.props.isRequire}
                  key={type}
                  type={type}
                  invoice={invoice}
                  homeAddresId={homeTypeId}
                />
              );
            })}

            <Row>
              <Cell>{this.lbl(`company.property.status`)}</Cell>
              <Cell>
                <CompanyStatusCard
                  invoiceId={invoice?.id}
                  company={invoice?.incomingCompany}
                  status={this.getFieldValue('status')}
                >
                  {this.lbl(`company.property.status.${this.getFieldValue('status')}`)}
                </CompanyStatusCard>
              </Cell>
            </Row>
            <Row key="viesCheckStatus">
              <Cell>{this.lbl(`company.property.ViesCheckStatus`)}</Cell>
              <Cell>
                {this.props.viesWork || this.state.loading ? (
                  <Loader small />
                ) : (
                  <HBox style={{ whiteSpace: 'nowrap' }} left>
                    <div style={{ width: '50%' }}>
                      <ViesLabel
                        vies={
                          this.state.viesStatus || this.state.viesStatus === false
                            ? this.state.viesStatus
                            : invoice?.incomingCompany?.viesCheckStatus
                        }
                      />
                    </div>
                    <span>
                      {' '}
                      {this.state.viesDate || this.state.viesDate
                        ? this.state.viesDate
                        : invoice?.incomingCompany?.viesCheckDate}
                    </span>
                  </HBox>
                )}
              </Cell>
            </Row>
          </List>
        </Container>
      </Card>
    );
  }
}

CreditorInfoCardComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    addressTypes: selectAddressTypes(),
    values: selectNewInvoice(),
    viesWork: selectWorks([REQUEST_VIES_CHECK, REQUEST_COMPANY]),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    update(dto, callback) {
      dispatch(updateInvoice(ownProps.invoice?.id, dto, callback));
    },
    setValue(value, name = null) {
      name = name ?? ownProps.type;
      dispatch(setNewInvoiceValue(name, value));
    },
    checkViesStatus(dto, callback) {
      dispatch(checkVies(dto, callback));
    },
    fetchCompany(callback) {
      dispatch(fetchCompany(ownProps.invoice?.incomingCompany?.id, callback));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const CreditorInfoCard = compose(withConnect, withRouter)(CreditorInfoCardComp);
